import React, { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import { LanguageProvider } from "@/i18n";
import { Loader } from "@/components/site/Loader";
import { CustomCursor } from "@/components/site/CustomCursor";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Approach } from "@/components/site/Approach";
import { WhatIBuild } from "@/components/site/WhatIBuild";
import { Transformation } from "@/components/site/Transformation";
import { FeaturedProjects } from "@/components/site/FeaturedProjects";
import { Different } from "@/components/site/Different";
import { Technology } from "@/components/site/Technology";
import { Stats } from "@/components/site/Stats";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  const [loaded, setLoaded] = useState(false);
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  useEffect(() => {
    if (window.location.search.includes("nolenis")) return;
    const lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <LanguageProvider>
      <div className="relative bg-[#050505] text-white min-h-screen" data-testid="app-root">
        <div className="grain" aria-hidden />
        <CustomCursor />
        <Loader onComplete={() => setLoaded(true)} />

        {/* scroll progress */}
        <motion.div className="fixed top-0 left-0 right-0 z-[90] h-[2px] origin-left bg-flame" style={{ scaleX: progress }} />

        <Nav show={loaded} />

        <main>
          <Hero ready={loaded} />
          <About />
          <Approach />
          <WhatIBuild />
          <Transformation />
          <FeaturedProjects />
          <Different />
          <Technology />
          <Stats />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
